export const environment = {
  production: false,
  uiUrl: 'https://store.dev.capium.co.uk/',
  appDomain: 'store.dev.capium.co.uk',
  /** Dev OneLogin API via APIM. */
  stsServerUrl: 'https://api.dev.capium.co.uk/onelogin',
  identityLoginUrl: 'https://onelogin.dev.capium.co.uk',
  clientId: 'capium-pilot',
  imagePath: '/assets/images',
  /** Dev Subscription Portal API via APIM. */
  apiVersionUrl: 'https://api.dev.capium.co.uk/store/api/v1/',
  commonapiVersionUrl: 'https://communicationframworkapi.dev.capium.co.uk/api/',
  helpDeskUrl: 'https://capium.freshdesk.com/support/home',
  diybooxDemoUrl: '',
  apiVersion2Url: 'https://api.dev.capium.co.uk/store/api/v2/',
  apiVersionUrlDirect: 'https://api.dev.capium.co.uk/store/api/v1/',
  apiVersion2UrlDirect: 'https://api.dev.capium.co.uk/store/api/v2/',
  /** Real APIM sets X-User-* - browser must not send UserId / X-User-*. */
  simulateApimHeaders: false,
  /** APIM swaps to Azure AD MI - UI sends OneLogin Bearer only. */
  useAzureAdBearer: false,
  /**
   * Sign-in systems this build accepts (core/auth/auth-providers.ts). A user is on the default
   * unless the entry link carries ?idp=onelogin|identity (kept for that browser tab). Each system's
   * token goes only to its own SP API base (dev: OneLogin through APIM, Identity direct to storeapi, because APIM accepts OneLogin tokens only).
   */
  auth: {
    defaultProvider: 'identity',
    onelogin: {
      enabled: true,
      authority: 'https://api.dev.capium.co.uk/onelogin',
      clientId: 'capium-pilot',
      homeUrl: 'https://onelogin.dev.capium.co.uk',
      loginUrl: 'https://onelogin.dev.capium.co.uk',
      profileUrl: 'https://onelogin.dev.capium.co.uk/profile',
      apiVersionUrl: 'https://api.dev.capium.co.uk/store/api/v1/',
      apiVersion2Url: 'https://api.dev.capium.co.uk/store/api/v2/',
    },
    identity: {
      enabled: true,
      authority: 'https://identity.dev.capium.co.uk',
      clientId: 'capium_timeandfee_angular',
      homeUrl: 'https://identity.dev.capium.co.uk',
      loginUrl: 'https://identity.dev.capium.co.uk/Account/Login',
      profileUrl: 'https://identity.dev.capium.co.uk/Manage',
      apiVersionUrl: 'https://storeapi.dev.capium.co.uk/api/v1/',
      apiVersion2Url: 'https://storeapi.dev.capium.co.uk/api/v2/',
    },
  },
};
